import { defineAsyncComponent } from 'vue'
export default {
  layout: defineAsyncComponent(() => import("/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/layouts/layout.vue").then(m => m.default || m))
}